import { createReducer } from '../../../utilities';

import { scope } from '../../../../actions/app/other/mpp/league';
import {
    REQUEST_FETCH_MPP_LEAGUE,
    SUCCESS_FETCH_MPP_LEAGUE,
    FAIL_FETCH_MPP_LEAGUE,
} from '../../../../actions/entities/league';

const initialMPPLeagueSupportState = {
    id: null,
    info: {
        isFetching: false,
        lastAction: null,
        lastPayload: {},
        needRefresh: true,
        updatedAt: null,
        success: false,
        error: false,
    }
};

function request(state, action) {
    return {
        ...state,
        info: {
            isFetching: true,
            lastAction: action.type,
            lastPayload: action.payload,
            needRefresh: false,
            updatedAt: null,
            success: false,
            error: false,
        }
    };
}

function success(state, action) {
    const { id, payload, receivedAt, success } = action;
    return {
        ...state,
        id: id || state.id,
        info: {
            ...state.info,
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            updatedAt: receivedAt,
            success,
            error: false,
        }
    };
}

function fail(state, action) {
    const { error, payload, type } = action;
    return {
        ...state,
        id: type === FAIL_FETCH_MPP_LEAGUE ? null : state.id,
        info: {
            ...state.info,
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            success: false,
            error,
        }
    };
}

export default createReducer(initialMPPLeagueSupportState, {
    [REQUEST_FETCH_MPP_LEAGUE]: request,
    [SUCCESS_FETCH_MPP_LEAGUE]: success,
    [FAIL_FETCH_MPP_LEAGUE]: fail,
}, scope);



// WEBPACK FOOTER //
// ./src/reducers/app/other/mpp/league.js